<ng-container *ngIf="!resetPassword">
    <div class="background bg-principal">
        <!-- Logo arriba -->
        <div class="logo-container">
            <img src="/assets/img/brand/handly-logo-white-dark.svg" alt="Handly" class="logo" />
        </div>

        <!-- Caja de recuperar contraseña -->
        <div class="login-box text-center">
            <h4>Recuperar contraseña</h4>
            <p class="subtitle">Introduce tu correo electrónico para restablecer tu contraseña</p>

            <mat-form-field class="w-100">
                <mat-label>Correo electrónico</mat-label>
                <mat-icon matPrefix class="iconoLogin">email</mat-icon>
                <input matInput type="email" placeholder="ejemplo@correo.com" [(ngModel)]="email" name="email"
                    required />
            </mat-form-field>

            <div class="buttons">
                <button class="btn primary" (click)="forgot()">Recuperar</button>
                <span class="goLogin" (click)="login()">Volver al login</span>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="resetPassword">
    <div class="background bg-principal">
        <!-- Logo -->
        <div class="logo-container">
            <img src="/assets/img/brand/handly-logo-white-dark.svg" alt="Handly" class="logo" />
        </div>

        <!-- Caja de nueva contraseña -->
        <div class="login-box text-center">
            <h4>Nueva contraseña</h4>
            <p class="subtitle">Introduce tu nueva contraseña para continuar</p>

            <mat-form-field class="w-100">
                <mat-label>Contraseña</mat-label>
                <mat-icon matPrefix class="iconoLogin">https</mat-icon>
                <input matInput [(ngModel)]="password" name="password" [type]="showNewPassword ? 'text' : 'password'"
                    placeholder="********" minlength="6" required (keyup.enter)="login()" #input />
                <mat-icon matSuffix (click)="showPassword(input)" class="click iconoLogin">
                    {{ showNewPassword ? 'visibility_off' : 'visibility' }}
                </mat-icon>
            </mat-form-field>


            <div class="buttons">
                <button class="btn primary" (click)="resetPass()">Cambiar</button>
            </div>
        </div>
    </div>
</ng-container>
